import axios from 'axios';
import { GetListRequestType } from './Types';

export const getList: GetListRequestType = async (payload) => {
	const url = window.host + '/PushMessage/GetList';
	try {
		const request = await axios.post(url, payload, {
			withCredentials: true,
		});
		return request.data;
	} catch (error: any) {
		throw new Error(
			'Не удалось загрузить список push-уведомлений. Подробности в консоле разработчика',
		);
	}
};

export const confirm = async (pushMessageId: string) => {
	const url = window.host + '/PushMessage/Esia/GoToConfirmation';
	try {
		const request = await axios.post(
			url,
			{ pushMessageId },
			{ withCredentials: true },
		);
		return request.data;
	} catch (error: any) {
		throw new Error(
			'Не удалось выполнить действие. Подробности в консоле разработчика',
		);
	}
};

export const cancel = async (pushMessageId: string) => {
	const url = window.host + '/PushMessage/Esia/CancelConfirmation';
	try {
		const request = await axios.post(
			url,
			{ pushMessageId },
			{ withCredentials: true },
		);
		return request.data;
	} catch (error: any) {
		throw new Error(
			'Не удалось выполнить действие. Подробности в консоле разработчика',
		);
	}
};
